export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block text-xs font-medium text-accent-400 bg-accent-500/20 px-3 py-1 rounded-full mb-4">
              随时随地吃瓜
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
              移动端畅享吃瓜体验
            </h2>
            <p className="text-background-300/80 text-sm md:text-base leading-relaxed max-w-lg mb-6">
              17吃瓜网已适配手机浏览器，无需下载APP，打开浏览器即可流畅观看所有吃瓜视频。随时随地刷最新黑料，不错过任何一个热搜。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机端立即体验
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-background-300/20 hover:border-background-300/40 text-background-200 font-medium px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>
          <div className="w-48 md:w-56 h-64 md:h-72 relative shrink-0">
            <div className="w-full h-full rounded-3xl border-4 border-background-300/30 bg-foreground-700 overflow-hidden">
              <div className="h-8 bg-foreground-600 flex items-center justify-center">
                <span className="text-background-400 text-[10px]">17吃瓜网</span>
              </div>
              <div className="p-3 space-y-2">
                {[1, 2, 3, 4].map((n) => (
                  <div key={n} className="flex gap-2 items-center">
                    <div className="w-10 h-10 rounded-lg bg-primary-500/30 shrink-0 flex items-center justify-center">
                      <i className="ri-play-fill text-primary-400 text-lg"></i>
                    </div>
                    <div className="flex-1 space-y-1">
                      <div className="h-2 bg-background-300/20 rounded w-full"></div>
                      <div className="h-2 bg-background-300/10 rounded w-3/4"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}